import Vue from 'vue'
import Router from 'vue-router'
import BasePage from '@/views/BasePage'
import Landingpage from '@/views/Landingpage'
import pages from '@/pages.js'

Vue.use(Router)
var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: isMobile ? '/home' : '/landing',
      name: 'BasePage',
      component: BasePage,
      children: pages.map((page) => {
        return {
          name: page.name,
          path: page.link,
          component: page.component
        }
      }
        )
    },
    {
      path: '/landing',
      name: 'Landingpage',
      component: Landingpage
    },
  ],
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active'
})
/*
function getRoutesList(routes, pre) {
  return routes.reduce((array, route) => {
    const path = `${pre}${route.path}`;

    if (route.path !== '*') {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }

    return array;
  }, []);
}

function generateSiteMap(){
  const list = getRoutesList(router.options.routes, 'http://schreinerei-schill.de/#/')
    .map(route => `<url><loc>${route}</loc></url>`)
    .join('\r\n');
  return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`;
}


console.log(generateSiteMap());*/

export default router;